'use strict'; // eslint-disable-line

module.exports = Dropdown;

/**
 * @type {jQuery|exports|module.exports|Function}
 */
var jQuery = require('jquery');
require('jquery-ui/ui/position.js');

var _require = require('rp-mq-breakpoints'),
    rpMqBreakpoints = _require.default,
    breakpointCodes = _require.breakpointCodes;

/**
 * @type {ItemList|exports|module.exports|Function}
 */


var ItemList = require('./itemList');

/**
 * Container for items list
 * @param container
 * @constructor
 */
function Dropdown(container) {
    this.container = container;

    this.$obj = jQuery('<div class="ui-dropdown"></div>');
    this.$pointer = jQuery('<div class="ui-dropdownPointer" data-test-selector="block-dropDownPointer"></div>');
    this.$header = jQuery('<div class="ui-dropdownHeader" data-test-selector="block-dropDownHeader"></div>');

    this.init();
}

Dropdown.prototype.CLASS_CONTAINER = 'ui-dropdown';
Dropdown.prototype.CLASS_POINTER = 'ui-dropdownPointer';
Dropdown.prototype.CLASS_HEADER = 'ui-dropdownHeader';

/**
 * Initialize
 * @returns {Dropdown}
 */
Dropdown.prototype.init = function () {
    this.$obj.addClass(this.CLASS_CONTAINER);

    this.$pointer.addClass(this.CLASS_POINTER);
    this.$header.addClass(this.CLASS_HEADER);

    this.bindEvents().initItemList().render();

    return this;
};

/**
 * Bind events
 * @returns {Dropdown}
 */
Dropdown.prototype.bindEvents = function () {
    jQuery(window).resize(this._onResizeHandler()).on('rpBreakpointsSwitch', this._onSwitchBreakpointHandler());

    return this;
};

/**
 * Compose objects into one jQuery object
 * @returns {jQuery}
 */
Dropdown.prototype.render = function () {
    return this.$obj.append(this.$pointer).append(this.$header).append(this.itemList.render());
};

/**
 * Initialize item list
 * @returns {Dropdown}
 */
Dropdown.prototype.initItemList = function () {
    var self = this;

    if (!this.itemList) {
        this.itemList = new ItemList(this.container);
    }

    this.itemList.empty();
    jQuery.each(this.container.$original.find('option'), function (index) {
        var $option = jQuery(this);

        self.itemList.addItem(index, $option.text(), $option.val());

        if ($option.is(':selected')) {
            self.itemList.selectItem(index);
        }
    });

    return this;
};

/**
 * Show dropdown
 * @returns {Dropdown}
 */
Dropdown.prototype.open = function () {
    this.$obj.show(0, this._onOpenHandler());

    return this;
};

/**
 * Close dropdown
 * @returns {Dropdown}
 */
Dropdown.prototype.close = function () {
    this.$obj.hide();

    return this;
};

/**
 * Check dropdown open status
 * @returns {boolean}
 */
Dropdown.prototype.isOpen = function () {
    return this.$obj.is(':visible');
};

/**
 * Align dropdown container relatively to the element
 * @param {jQuery} $of
 * @returns {Dropdown}
 */
Dropdown.prototype.alignToElement = function ($of) {
    this.$obj.position(jQuery.extend(this.container.settings.position, {
        of: $of
    }));

    return this;
};

/**
 * Change width of dropdown according to button width
 * @returns {Dropdown}
 */
Dropdown.prototype.recalculateWidth = function () {
    this.$obj.css('width', this.container.$obj.outerWidth());

    return this;
};

/**
 * @returns {Function}
 * @private
 */
Dropdown.prototype._onOpenHandler = function () {
    var self = this;

    return function () {
        self.recalculateWidth().alignToElement(self.container.$obj);
    };
};

/**
 * @returns {Function}
 * @private
 */
Dropdown.prototype._onSwitchBreakpointHandler = function () {
    var self = this;

    return function () {
        self.recalculateWidth();
    };
};

/**
 * @returns {Function}
 * @private
 */
Dropdown.prototype._onResizeHandler = function () {
    var self = this;

    return function () {
        if (rpMqBreakpoints.current().code !== breakpointCodes.EXTRA_NARROW) {
            return;
        }

        self.recalculateWidth();
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-select/lib/dropdown.js
// module id = 1452
// module chunks = 1